import projectUtils from "../../../../utils/project-utils.js";

export const vehicleStatusObj = {
  DECREASE: "Baixado",
  AVAILABLE: "Disponível",
  MAINTENANCE: "Em manutenção",
  USING: "Em uso",
  GARNISHED: "Guarnecido",
}
export const vehicleStatusArr = Object.entries(vehicleStatusObj).map(([key, value]) => ({value: key, label: value}))

export const vehicleTypeObj = {
  AIRCRAFT: "Aeronave",
  CAR: "Automóvel",
  BICYCLE: "Bicicleta",
  TRUCK: "Caminhão",
  STATION_WAGON: "Caminhonete",
  PICKUPB: "Camioneta",
  ELECTRICCAR: "Carro Elétrico",
  SHIP: "Embarcação",
  WINCH: "Guincho",
  MINIBUS: "Micro-ônibus",
  MOTORCYCLE: "Motocicleta",
  BUS: "Ônibus",
  QUADRICYCLE: "Quadriciclo",
  VAN: "Van",
  UTILITY: "Utilitário",
};

export const vehicleTypeArr = Object.entries(vehicleTypeObj).map(
  ([key, value]) => ({
    value: key,
    label: value
  })
);

export const vehicleMaintenanceStatusArr = [
  {value: "expire", label:"Vencida"},
  {value: "toexpire", label:"A vencer"},
]

export const fuelTypeArr = [
  { value: "arla32", label: "Arla 32 (litros)" },
  { value: "diesel", label: "Diesel (litros)" },
  { value: "electric", label: "Elétrico (kWh)" },
  { value: "ethanol", label: "Etanol (litros)" },
  { value: "flex", label: "Flex (litros)" },
  { value: "gasoline", label: "Gasolina (litros)" },
  { value: "gnv", label: "GNV (m3)" }
];

export const vehicleOwnershipArr = [
  { value: "owned", label: "Próprio" },
  { value: "leased", label: "Locado" },
  { value: "loan", label: "Comodato" }
];
export const initialVehiclesForm = {
  status: "",
  prefix: "",
  plate: "",
  renavam: "",
  chassis: "",
  brand: "",
  model: "",
  sub_model: "",
  color: "",
  year: "",
  model_year: "",
  type: "",
  tank_max: "",
  fuel_type: "",
  actual_km: "",
  allow_failure_reporting: false,
  km_control: false,
  scheme: "",
  owner_id: "",
  vehicle_classes_id: "",
  inspection_items_id: "",
  observation: "",
  next_date: "",
  lines: "",
  columns: "",
  reviewItems: [],
  vehicleId: "",
  vehicle_damage: [],
  video_cameras: []
};

export const buildVehicleJSON = (form, reviewItems) => {

  const formattedReviewItems = reviewItems.map(({applyEffect, ...el}) => ({
    ...el,
    date: projectUtils.formatDate(el.date, "DD/MM/YYYY"),
    next_date_revision: projectUtils.formatDate(el.next_date_revision, "DD/MM/YYYY"),
    vehicle_id: form.vehicleId
  }))

  return {
    status: form.status,
    prefix: form.prefix,
    plate: form.plate,
    renavam: form.renavam,
    chassis: form.chassis,
    brand: form.brand,
    model: form.model,
    sub_model: form.sub_model,
    color: form.color,
    year: form.year,
    model_year: form.model_year,
    type: form.type,
    tank_max: form.tank_max,
    fuel_type: form.fuel_type,
    actual_km: form.actual_km,
    scheme: form.scheme,
    owner_id: form.owner_id,
    vehicle_classes_id: form.vehicle_classes_id,
    inspection_items_id: form.inspection_items_id,
    km_control: form.km_control,
    allow_failure_reporting: form.allow_failure_reporting,
    observation: form.observation,
    next_date: form.next_date,
    lines: form.lines,
    columns: form.columns,
    vehicleId: form.vehicleId,
    reviewItems: formattedReviewItems,
    vehicle_damage: JSON.stringify(form.vehicle_damage) ?? [],
    video_cameras: JSON.stringify(form.video_cameras) ?? ""
  };
};

export const buildVehicleForm = (data, cameras) => {
  if (!data) return initialVehiclesForm;

  const vehicleCameraIds = (data.video_cameras ?? []).map(c => c.vms_camera_id);

  const camerasArr = cameras
    .filter(camera => vehicleCameraIds.includes(camera.id))
    .map(({ id, cameraName, vmsName, vmsId }) => ({
      cameraId: id,
      cameraName,
      vmsName,
      vmsId
    }));

  return {
    status: data.status ?? "",
    prefix: data.prefix ?? "",
    plate: data.plate ?? "",
    renavam: data.renavam ?? "",
    chassis: data.chassis ?? "",
    brand: data.brand ?? "",
    model: data.model ?? "",
    sub_model: data.sub_model ?? "",
    color: data.color ?? "",
    year: data.year ?? "",
    model_year: data.model_year ?? "",
    type: data.type ?? "",
    tank_max: data.tank_max ?? "",
    fuel_type: data.fuel_type ?? "",
    actual_km: data.actual_km ?? "",
    allow_failure_reporting: data.allow_failure_reporting ?? false,
    km_control: data.km_control ?? false,
    scheme: data.scheme ?? "",
    owner_id: data.owner_id ?? "",
    vehicle_classes_id: data.vehicle_classes_id ?? "",
    inspection_items_id: data.inspection_items_id ?? "",
    observation: data.observation ?? "",
    lines: "",
    columns: "",
    reviewItems: [],
    vehicleId: data.id ?? "",
    vehicle_damage: [],
    video_cameras: camerasArr
  };
};